export function getPosHubMenuCategoryItemIds(category) {
  if (!category || typeof category !== 'object') return [];
  const raw = category.itemIds ?? category.item_ids ?? [];
  return Array.isArray(raw) ? raw.map((id) => String(id)) : [];
}

/** PosHub drag-sort updates category.itemIds; filter alone keeps global API order (wrong for shared items). */
export function sortMenuItemsForCategory(items, category) {
  const ids = getPosHubMenuCategoryItemIds(category);
  if (!ids.length || !Array.isArray(items) || items.length < 2) return items;
  const rank = (item) => {
    const itemId = item?.id == null ? '' : String(item.id);
    const idx = ids.indexOf(itemId);
    return idx >= 0 ? idx : 1_000_000;
  };
  return [...items].sort((a, b) => {
    const diff = rank(a) - rank(b);
    if (diff !== 0) return diff;
    return String(a?.name || '').localeCompare(String(b?.name || ''));
  });
}
